import PosCartActions from '../../../actions/PosCartActions';
import NotificationActions from '../../../actions/NotificationActions';
import PopupActions from '../../../actions/PopupActions';
import UserStore from '../../../stores/UserStore';
import PosCartStore from '../../../stores/PosCartStore';
import AjaxPromises from '../../../utils/AjaxPromises';
import { endPoints as PosEndPoints } from '../../../constants/PosConstants';
import { endPoints as PosCartEndPoints } from '../../../constants/PosCartConstants';
import * as _ from 'lodash';
import Price from '../../form/Price.react';

class Bulk extends React.Component {

    constructor(props) {
        super(props);

        let data = this.props.data;

        this.state = {
            item        : data.hasOwnProperty('TotalGrams') ? data : false,
            bulk        : false,
            weight      : '',
            amount      : '',
            load        : false,
            total       : 0,
            selected    : false,
            weightToBuy : 0,
            unitPrice   : 0,
            actualWeight: '',
            actualWeightTouched: false,
            amountCustomerCanBuy: ''
        };

        this.onAmountChange = this.onAmountChange.bind(this);
        this.onActualWeightChange = this.onActualWeightChange.bind(this);
        this.onWeightChange = this.onWeightChange.bind(this);
        this.calcWeight = _.debounce(this.calcWeight.bind(this), 500);
        this.calcAmount = this.calcAmount.bind(this);
        this.addBulk = this.addBulk.bind(this);
        this.getWeightFromScale = this.getWeightFromScale.bind(this);
    }

    componentDidMount() {
        $('#bulk-weight').focus();

        if (!this.props.data.hasOwnProperty('TotalGrams')) {
            AjaxPromises.POST(PosEndPoints.POS_PRODUCT_SEARCH, UserStore.getApiData({
                SearchString : this.props.data.SerialNo
            })).then(res => {
                if (res.Result && res.Data.length === 1) {
                    this.setState({
                        item : res.Data[0]
                    });
                } else {
                    NotificationActions.error('Something went wrong');
                }
            });
        }
    }

    onAmountChange(e) {
        this.setState({ amount : e.target.value });
    }

    onWeightChange(e) {
        let weight = e.target.value;
        const validatedWeight = weight.replace(/[^.\d]/, '');

        let actualWeight = this.state.actualWeightTouched ? this.state.actualWeight : validatedWeight;
        this.setState({ weight : validatedWeight, actualWeight: actualWeight }, () => 
            this.calcWeight()
        );
    }

    getWeightFromScale(weight) {
        this.setState({ weight : weight });
    }

    calcWeight() {
        let self = this;
        let formData = UserStore.getApiData();
        let weight  = this.state.weight;

        formData.Guest_id = this.props.guest.Guest_id;
        formData.Wgt = weight;
        formData.ProductId = this.props.data.ProductId;
        formData.SerialNumber = this.props.data.SerialNo;

        this.setState({ load : true }, () => {
            AjaxPromises.POST(PosEndPoints.GET_BULK_BY_WEIGHT,
                formData).then(res =>  {
                    self.setState({
                                total : res.Data[0].ResultTxt * formData.Wgt,
                                unitPrice : res.Data[0].ResultTxt,
                                load : false,
                                selected : 'weight',
                                weightToBuy : self.state.actualWeight,
                            });
                        });
                    });
    }

    calcAmount() {
        let self = this;
        let query = $('#pos-search-query').val();
        let guest = this.props.guest;
        const allotment = PosCartStore.getAllotment(guest, this.props.data.MasterCategory);
        let formData            = UserStore.getApiData();

        formData.Guest_id       = this.props.guest.Guest_id;
        formData.DollarAmount   = this.state.amount;
        formData.ProductId      = this.props.data.ProductId;
        formData.SerialNo       = this.props.data.SerialNo;
        formData.PricingId      = 0;
        // this.props.selectItem(false);

        this.setState({ load : true }, () => {
            AjaxPromises.POST(PosEndPoints.GET_BULK_BY_AMOUNT,
                formData).then(res => {
                    if (res.Data[0].PurchaseGrams > (allotment.max - allotment.cart - allotment.used)) {
                        NotificationActions.alert('Allotment left: '+(self.props.guest.Allotment - allotment.cart - allotment.used)+'g');
                    } else {
                        self.setState({ amountCustomerCanBuy: res.Data[0].PurchaseGrams+'g'})
                    }
                }
            );
        });
    }

    addBulk() {
        // TODO :: sometimes if you add value $1 it will return PurchaseGrams 0
        // check that purchasegrams is greater thatn 0 before you can add

        if (!this.state.selected || !this.state.item)
            return;

        let { item, actualWeight, weight }  = this.state;
        let { guest } = this.props;
        
        if (parseFloat(actualWeight) > parseFloat(item.TotalGrams)) {
            NotificationActions.alert('Only '+item.TotalGrams+'g is available');
            return;
        }

        const allotment = PosCartStore.getAllotment(guest, item.MasterCategory);

        let formData        = UserStore.getApiData();
        formData.ShipmentId = guest.ShipmentId;
        formData.SerialNo   = item.SerialNo;
        formData.Grouping   = 'No';
        formData.ProdId     = item.ProductId;
        //formData.AvailOz    = item.TotalOz;
        formData.AvailOz = guest.Allotment - allotment.used - allotment.cart;
        formData.OrderId    = 0;
        formData.DiscountAmt = 0;
        formData.Comments   = '';
        formData.InvId      = 0;

        item.CannbisProduct = 'Yes';

        formData.SubTotal   = _.round(this.state.total / actualWeight, 4);
        formData.UnitPrice  = _.round(this.state.total / actualWeight, 4);
        formData.Weight     = actualWeight;
        formData.PricedWeight = this.state.weight;
        
        PosCartActions.addBulkItemToCart(formData, guest, item);
        setTimeout(() => {
            PopupActions.close();
        }, 10)
    }

    onActualWeightChange(e) {
        this.setState({ actualWeight: e.target.value, actualWeightTouched: true});
    }

    render() {
        let item  = this.state.item;
        let total = this.state.total;

        return (

                <div className='popup__content bulk'>

                    <div className='popup-header'>
                        BULK FLOWER

                        <div
                            className='popup-close'
                            onClick={() => { PopupActions.close(); }}>

                            <i className='fa fa-times' aria-hidden='true' />
                        </div>
                    </div>

                    <div className='bulk__header'>
                        <div className='bulk__header--available'>
                            <ul>
                                <li>Available</li>
                                <li>{item.TotalGrams}g</li>
                            </ul>
                        </div>

                        <div className='bulk__header--strain'>
                            <ul>
                                <li>Strain</li>
                                <li>{item.ProductDesc || item.ProductDescription || item.Product}</li>
                            </ul>
                        </div>
                        <div style={{'clear':'both'}} />
                    </div>

                    <div className='bulk__content'>
                        <ul>
                            <li>
                                <h1>Free Weight</h1>
                                <h2>Weight to Price:</h2>
                                <div className='bulk__content--data'>
                                    <input
                                        type='text'
                                        className='input-text-1 free-weight'
                                        id='bulk-weight'
                                        value={this.state.weight}
                                        onChange={this.onWeightChange} />
                                    {/* <div
                                        className='bulk__content--add'
                                        onClick={this.calcWeight}>

                                        ENTER
                                    </div> */}
                                </div>
                            {
                                !!UserStore.getState().selectedLocation.EnterActualWeight && [
                                <h2>Actual Weight:</h2>,
                                <div className='bulk__content--data'>
                                    <input
                                        type='text'
                                        className='input-text-1 actual'
                                        id='bulk-weight-actual'
                                        value={this.state.actualWeight}
                                        onChange={this.onActualWeightChange} />
                                </div>
                                ]
                            }
                            </li>

                            <li>
                                <h1>HOW MUCH CAN I GET</h1>
                                <h2>Dollars: </h2>
                                <div className='bulk__content--data'>
                                   <input
                                        type='text'
                                        className='input-text-1'
                                        id='bulk-amount'
                                        value={this.state.amount}
                                        onChange={this.onAmountChange} />

                                    <div
                                        className='bulk__content--add'
                                        onClick={this.calcAmount}>

                                        ENTER
                                    </div>
                                </div>

                                <div className='bulk__amount'>
                                    <div className='bulk__amount--title'>
                                        Amount customer can buy: { this.state.amountCustomerCanBuy }
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>

                    <div style={{'clear':'both'}} />

                    <div className='bulk__footer'>

                        <Price
                            className='bulk__footer--total'
                            price={total}
                            dollar={true} />

                        <div
                            className='bulk__footer--add'
                            onClick={this.addBulk}>

                            { item ? 'ADD' : <i className='fas fa-circle-notch fa-spin' />}
                        </div>
                    </div>
                </div>

        );
    }
}

export default Bulk;



// WEBPACK FOOTER //
// ./ui_src/app/components/pos/bulk/Bulk.react.jsx